var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 40,
    viewBox: "0 0 54 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2222 0C8.64889 2.68 0 14.6311 0 26.0556C0 34.8778 6.19111 40 12.8911 40C18.7022 40 24.4444 36.0067 24.4444 28.9356C24.4444 23.1533 20.2111 18.3644 14.6756 17.4933C15.1578 13.04 19.4867 6.58 24.4089 4.72444L22.2222 0ZM51.1111 0C37.5378 2.68 28.8889 14.6311 28.8889 26.0556C28.8889 34.8778 35.08 40 41.78 40C47.5911 40 53.3333 36.0067 53.3333 28.9356C53.3333 23.1533 49.1 18.3644 43.5644 17.4933C44.0467 13.04 48.3756 6.58 53.2978 4.72444L51.1111 0Z",
    fill: "#2EAD9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.df771d240d349ae709f50a3b5c0bd017.svg";
export { ForwardRef as ReactComponent };